// Blog helpers shared across the blog list, home teaser and detail page.
// NOTE: the slugify algorithm here is mirrored in scripts/blog-slug.js (CJS)
// for the sitemap generator and SEO injector — keep the two in sync.

export const slugify = (text) =>
    String(text || '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80)
        .replace(/-+$/g, '');

// Canonical path for a blog post. Prefers the server-stored slug, falling back
// to a title-derived slug for older payloads.
export const blogPath = (blog) => `/blog/${(blog && blog.slug) || slugify(blog && blog.title)}`;

// Path for a tag landing page. Accepts a display label or an existing slug.
export const tagPath = (tag) => `/blog/tag/${slugify(tag)}`;

// A 24-char hex string looks like a Mongo _id (used for legacy /blog/<id> links).
export const isMongoId = (v) => /^[a-f0-9]{24}$/i.test(String(v || ''));

// Sort blogs newest-first by creation date.
export const byNewest = (a, b) => new Date(b.creation_date) - new Date(a.creation_date);

// Strip HTML to plain text.
export const toPlainText = (html) =>
    String(html || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

// Estimated reading time in minutes (~200 wpm), min 1.
export const readingTimeMinutes = (html) => {
    const words = toPlainText(html).split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(words / 200));
};

// Human-readable date, resilient to invalid input.
export const formatDate = (dateString, locale = 'en-IN') => {
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long', day: 'numeric' }).format(d);
};
